import { IGoal } from "motw_core/Entity/IGoal";
import * as React from "react";
import { EGlyphicon } from "source/app/presentation/Shared/Glyphicon/EGlyphicon";
import Data from "source/app/services/Data";
import ClientDataProvider from "source/app/services/External/ClientDataProvider/ClientDataProvider";
import IconWithText from "source/app/services/Shared/IconWithText/IconWithText";
import { IGameIdentityDTO } from "../../../../../../../../../../motw_core/DTOs/IGameIdentityDTO";
import { resourceNameGameIdentityGoal } from "../../../../../../../../../../motw_core/Entity/IGameIdentityGoal";
import { IGameIdentityScoresState } from "../../../../GameIdentityScores";
import { ShowIdentityDetails } from "../../../Details/ShowIdentityDetails";
import * as toastr from "toastr";

export function AddGoalToGameIdentityIcon({
    identity,
    goals,
    selectedGoalName,
    goalNamesLoggedToday,
}: {
    identity: IGameIdentityDTO;
    goals: IGoal[];
    selectedGoalName: string;
    goalNamesLoggedToday: string[];
}) {
    return (
        <IconWithText
            iconSuffix={EGlyphicon.plus}
            whenClicked={async () =>
                HandleAddingGoalAsync(
                    goals,
                    selectedGoalName,
                    identity,
                    goalNamesLoggedToday
                )
            }
            displayAsBlock={false}
        />
    );
}

async function HandleAddingGoalAsync(
    goals: IGoal[],
    selectedGoalName: string,
    identity: IGameIdentityDTO,
    goalNamesLoggedToday: string[]
) {
    const selectedGoal = goals.find((goal) => goal.name === selectedGoalName)!;

    await ClientDataProvider.AddRecordAsync(resourceNameGameIdentityGoal, {
        gameidentityid: identity.id,
        goalid: selectedGoal.id,
    });

    const identityType = identity.iscombo ? `combo` : `identity`;

    toastr.success(
        `Added the goal '${selectedGoalName}' to the ${identityType} '${identity.name}'`
    );

    Data.Load.Single.ByStateTarget<IGameIdentityScoresState>(
        "gameIdentityScores"
    );

    var newIdentity: IGameIdentityDTO = {
        ...identity,
        goalNames: [...identity.goalNames, selectedGoalName],
    };

    ShowIdentityDetails(newIdentity, goalNamesLoggedToday);
}
